import { render, staticRenderFns } from "./ResultadoPreguntas.vue?vue&type=template&id=697f860c&scoped=true"
import script from "./ResultadoPreguntas.vue?vue&type=script&lang=js"
export * from "./ResultadoPreguntas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697f860c",
  null
  
)

export default component.exports